import { type ChangeEvent } from 'react'
import { Input, Stack, Text } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import { REFERENCE_MAX_LENGTH } from '@/features/transfer/model/constants'

type ReferenceFieldProps = {
  value: string
  onChange: (next: string) => void
  error?: string | null
  label?: string
}

const ASSERTIVE_THRESHOLD = 5

/** Optional reference message with a live "N/135 characters left" counter. */
export const ReferenceField = ({
  value,
  onChange,
  error,
  label,
}: ReferenceFieldProps) => {
  const { t } = useTranslation()
  const resolvedLabel = label ?? t('reference.defaultLabel')
  const remaining = REFERENCE_MAX_LENGTH - value.length

  return (
    <Stack direction='vertical' space='8'>
      <Input
        name='reference'
        label={resolvedLabel}
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        autoComplete='off'
        maxLength={REFERENCE_MAX_LENGTH}
        aria-invalid={Boolean(error)}
      >
        {error ? <Input.Hint variant='error'>{error}</Input.Hint> : null}
      </Input>
      <div aria-live={remaining < ASSERTIVE_THRESHOLD ? 'assertive' : 'polite'}>
        <Stack direction='horizontal' justify='flex-end'>
          <Text variant='small' color='neutral-alternate'>
            {t('reference.charsLeft', { remaining, max: REFERENCE_MAX_LENGTH })}
          </Text>
        </Stack>
      </div>
    </Stack>
  )
}
